/* eslint-disable @typescript-eslint/dot-notation */
import { Injectable } from '@angular/core';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { cloneDeep } from 'lodash';
import { ExportJSONFileModel } from '../models/export-file.model';
import { IExportSanitizer } from './export-sanitizer.interface';

@Injectable()
export class ExportSanitizer implements IExportSanitizer {
	public sanitize(fileModel: ExportJSONFileModel): ExportJSONFileModel {
		const parsedFileModel: ExportJSONFileModel = cloneDeep(fileModel);

		for (const data of parsedFileModel.TABLE_DATA) {
			// if is_interval_related = N for a table, both depth_from and depth_to are not mandatory
			// user can leave empty these fields when adding/editing a record
			if (
				data[WorkspaceDatabaseKeys.columns.depthFrom] !== undefined &&
				data[WorkspaceDatabaseKeys.columns.depthTo] !== undefined
			) {
				data.depth_from = data.depth_from.toString();
				data.depth_to = data.depth_to.toString();
			}

			for (const excludedKey of WorkspaceDatabaseKeys.exportExcludedKeys) {
				if (data.hasOwnProperty(excludedKey)) {
					delete data[excludedKey];
				}
			}
		}

		for (const refTable of parsedFileModel.FusionReferenceTables) {
			for (const excludedKey of WorkspaceDatabaseKeys.exportExcludedKeys) {
				if (refTable.hasOwnProperty(excludedKey)) {
					delete refTable[excludedKey];
				}
			}
		}

		for (const dataColumn of parsedFileModel.FusionDataColumns) {
			for (const excludedKey of WorkspaceDatabaseKeys.exportExcludedKeys) {
				if (dataColumn.hasOwnProperty(excludedKey)) {
					delete dataColumn[excludedKey];
				}
			}
		}

		return parsedFileModel;
	}
}
